import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';
import { weekdays } from 'jalali-moment';
import DeleteModalSnapp from '../../../components/deleteModal/DeleteModalSnapp';

const SnappMenus = () => {
  const { branchId, unitId, categoryId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [taxPercent, setTaxPercent] = useState(0);
  const [gridFilter, setGridFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    snappCategoryId: categoryId,
    size: 20,
    part: 1,
    title: '',
    total: 0,
    parts: 0
  });
  const [snappSecurity, setSnappSecurity] = useState({
    vendorCode: "",
    snappToken: ""
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    description: "",
    position: 0,
    price: 0,
    containerPrice: 0,
    saleMenuId: 0,
    schedules: "[]",
    vat: 0,
    active: true,
    disable: false,
    //disableUntil: "",
    snappCategoryId: categoryId,
    startTime : "",
    endTime : "",
    saleUnitId: unitId,
    branchId: branchId,
    vendorCode: "",
    snappToken: "",
    saveOnSnapp: true,
    snappCode: null
  });
  const [saleMenus, setSaleMenus] = useState([]);
  const [ddlMenus, setDdlMenus] = useState([]);
  const [saleMenuFilter, setSaleMenuFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    menuType: 0,
    categoryId: 0,
    size: 20,
    part: 1,
    title: '',
    total: 0,
    parts: 0
  });

  const [snappCategory, setSnappCategory] = useState({
    id: 0,
    unitId: unitId,
    categoryId: 0,
    size: 20,
    part: 1,
    title: ''
  });

  const [schedules, setSchedules] = useState([]);

  const [scheduleModel, setScheduleModel] = useState({
    dayTitle: "",
    day: 1,
    start: "",
    stop: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [showMenuSearch, setShowMenuSearch] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageTitle, setPageTitle] = useState("");

  const [snappRecords, setSnappRecords] = useState({
    categories: [],
    products: [],
    gridData: [],
    visibility: false
  });

  const [selectedSnappItem, setSelectedSnappItem] = useState(null);

  const mapModel = (model) => {
    formModel.id = model.id;
    formModel.title = model.title;
    formModel.description = model.description;
    formModel.position = model.position;
    formModel.price = model.price;
    formModel.containerPrice = model.containerPrice;
    formModel.saleMenuId = model.saleMenuId;
    formModel.schedules = model.schedules;
    formModel.vat = model.vat;
    formModel.active = model.active;
    formModel.disable = model.disable;
    //formModel.disableUntil = model.disableUntil;
    formModel.snappCategoryId = model.snappCategoryId;
    formModel.saleUnitId = model.saleUnitId;
    formModel.branchId = model.branchId;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModel.snappToken = snappSecurity.snappToken;
    formModel.saveOnSnapp = true;
    formModel.snappCode = null;
    setFormModel({ ...formModel });
  };

  const bindWeekDays = () => {
    var weekDays = methods.getPersianWeekDays();
    var schList = [];
    weekDays.map((item) => {
      schList.push({
        dayTitle: item.title,
        day: item.id,
        start: formModel.startTime,
        stop: formModel.endTime,
      });
    });
    setSchedules(schList);
  };

  console.log(formModel.schedules)

  const getTaxSetting = async () => {
    var resp = await apiMethod.getSettingByName(branchId, 'Tax');
    if (methods.showApiErrors(resp)) {
      var strTax = methods.getSettingItemByKey(resp.data.settingItems, 'TaxPercent');
      formModel.vat = strTax;
      setFormModel({ ...formModel });
      setTaxPercent(strTax);
    }
  };

  const getGridData = async (showLoading) => {
    if (showLoading)
      setLoading(true);
    const response = await apiMethod.getSnappMenus(gridFilter.branchId, gridFilter.unitId, gridFilter.snappCategoryId, gridFilter.size, gridFilter.part, gridFilter.title);
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(response)) {
      gridFilter.total = response.total;
      gridFilter.parts = methods.calcPageParts(response.total, gridFilter.size);
      setGridFilter({ ...gridFilter });
      setGridData(response.data);
    }
  };

  const getSnappCategoryInfo = async () => {
    const response = await apiMethod.getCategoryInfo(categoryId);
    if (!methods.showApiErrors(response))
      return false;
    snappCategory.menuCategoryId = response.data.menuCategoryId;
    setSnappCategory(response.data);
    setPageTitle(response.data.title);

  };

  const getCategoryMenus = async (showLoading) => {
    if (showLoading)
      setLoading(true);

    saleMenuFilter.categoryId = snappCategory.menuCategoryId;
    const response = await apiMethod.findSaleMenusForSnapp(saleMenuFilter.branchId, saleMenuFilter.unitId, saleMenuFilter.menuType, saleMenuFilter.categoryId, 200, 1, "");
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(response)) {
      setDdlMenus(response.data);
    }
  };

  const getSaleMenus = async (showLoading) => {
    if (showLoading)
      setLoading(true);

    saleMenuFilter.categoryId = snappCategory.menuCategoryId;
    const response = await apiMethod.findSaleMenusForSnapp(saleMenuFilter.branchId, saleMenuFilter.unitId, saleMenuFilter.menuType, saleMenuFilter.categoryId, saleMenuFilter.size, saleMenuFilter.part, saleMenuFilter.title);
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(response)) {
      saleMenuFilter.total = response.total;
      saleMenuFilter.parts = methods.calcPageParts(response.total, saleMenuFilter.size);
      setSaleMenuFilter({ ...saleMenuFilter });
      setSaleMenus(response.data);
    }
  };

  const setSnappToken = async () => {
    const response = await apiMethod.getSnappToken(branchId, unitId);
    if (!methods.showApiErrors(response))
      return false;
    snappSecurity.snappToken = response.data.token;
    snappSecurity.vendorCode = response.data.clientId;
    setSnappSecurity({ ...snappSecurity });
  };

  const getSnappData = async () => {
    const response = await apiMethod.getSnappRecordes({
      vendorCode: snappSecurity.vendorCode,
      snappToken: snappSecurity.snappToken
    });

    if (!methods.showApiErrors(response))
      return false;

    snappRecords.categories = response.data.categories;
    snappRecords.products = response.data.products;
    snappRecords.gridData = response.data.products;
    snappRecords.visibility = true;
    setSnappRecords({ ...snappRecords });
  }

  const setFromSnapp = (item) => {
    formModel.snappCode = item.productCode;
    formModel.saveOnSnapp = false;
    setFormModel({ ...formModel });

    snappRecords.visibility = false;
    setSnappRecords({ ...snappRecords });

    setSelectedSnappItem(item);
  }

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getTaxSetting();
      await getSnappCategoryInfo();
      await getGridData(false);
      await setSnappToken();
      await getSaleMenus(false);
      await getCategoryMenus(false);
      bindWeekDays();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const resetForm = () => {
    mapModel({
      id: 0,
      title: "",
      description: "",
      position: 0,
      price: 0,
      containerPrice: 0,
      saleMenuId: 0,
      schedules: "[]",
      vat: formModel.vat,
      active: true,
      disable: false,
      snappCategoryId: categoryId,
      saleUnitId: unitId,
      branchId: branchId,
      vendorCode: formModel.vendorCode,
      snappToken: formModel.snappToken
    });
    setShowModal(false);
    setShowDeleteModal(false);
    setShowMenuSearch(true);
  };

  const getItemInfo = async (id) => {
    setLoading(true);
    const response = await apiMethod.getSnappMenuInfo(id);
    if (!methods.showApiErrors(response))
      return false;

    mapModel(response.data);
    let schList = JSON.parse(formModel.schedules);
    setSchedules(schList);
    setShowMenuSearch(false);
    setSelectedSnappItem(null);
    setShowModal(true);
    setLoading(false);
  };

  const normalizeModel = () => {
    formModel.snappToken = snappSecurity.snappToken;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModel.schedules = JSON.stringify(schedules);
    setFormModel({ ...formModel });
  };

  const createItem = async () => {
    normalizeModel();
    if (!isValidForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createMenuSnapp(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const setMenu = (menu) => {
    formModel.title = menu.title;
    formModel.saleMenuId = menu.id;
    formModel.price = parseInt(menu.price / 10);
    formModel.containerPrice = parseInt(menu.packagingPrice / 10);
    formModel.description = menu.description;
    setFormModel({ ...formModel });
    setShowMenuSearch(false);
  };

  const changeMenuItem = (menuId) => {
    var saleMenuId = parseInt(menuId);
    var menu = saleMenus.find(x => x.id === saleMenuId);
    setMenu(menu);
  };

  const isValidForm = () => {
    var errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('عنوان محصول باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.saleMenuId === 0)) {
      errors.push('منو باید انتخاب شده باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.price) || formModel.price === 0) {
      errors.push('قیمت محصول باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.vat) || formModel.vat === 0) {
      errors.push('مالیات باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.description)) {
      errors.push('توضیحات باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.containerPrice)) {
      errors.push('هزینه ظرف باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(formModel.position) || formModel.position === 0) {
      errors.push('ترتیب نمایش باید مقدار داشته باشد.');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const resetFilters = () => {
    gridFilter.branchId = branchId;
    gridFilter.unitId = unitId;
    // gridFilter.snappCategoryId = snappCategoryId;
    gridFilter.title = '';
    gridFilter.size = 20;
    gridFilter.part = 1;
    setGridFilter({ ...gridFilter })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    gridFilter.part = i;
    setGridFilter({ ...gridFilter });
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (gridFilter.parts < gridFilter.part + 1) {
        return false;
      }
      callPager(gridFilter.part + 1);
    } else {
      if (gridFilter.part === 1) {
        return false;
      }
      callPager(gridFilter.part - 1);
    }
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= gridFilter.parts; i++) {
      pages.push(
        <li key={i} className={gridFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetSaleMenuFilter = () => {
    saleMenuFilter.branchId = branchId;
    saleMenuFilter.unitId = unitId;
    saleMenuFilter.title = '';
    saleMenuFilter.size = 20;
    saleMenuFilter.part = 1;
    setSaleMenuFilter({ ...saleMenuFilter })
  };

  const searchSaleMenuItem = async () => {
    setLoading(true);
    await getSaleMenus();
    setLoading(false);
  };

  const clearSaleMenuSearch = async () => {
    setLoading(true);
    resetSaleMenuFilter();
    await getSaleMenus();
    setLoading(false);
  };

  const SaleMenuCallPager = async (i) => {
    setLoading(true);
    saleMenuFilter.part = i;
    setSaleMenuFilter({ ...saleMenuFilter });
    await getSaleMenus();
    setLoading(false);
  };

  const SaleMenuMovePagerPart = (isForward) => {
    if (isForward) {
      if (saleMenuFilter.parts < saleMenuFilter.part + 1) {
        return false;
      }
      SaleMenuCallPager(saleMenuFilter.part + 1);
    } else {
      if (saleMenuFilter.part === 1) {
        return false;
      }
      SaleMenuCallPager(saleMenuFilter.part - 1);
    }
  };

  const SaleMenuMakePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= saleMenuFilter.parts; i++) {
      pages.push(
        <li key={i} className={saleMenuFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { SaleMenuCallPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const switchToAllCategoriesView = () => {
    setShowMenuSearch(true);
  };

  const openNewForm = async () => {
    resetForm();
    setSelectedSnappItem(null);
    await searchSaleMenuItem();
    setShowModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَSanpToDelete = (snap) => {
    setFormModel(snap);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeMenuSnapp(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const filterSnappData = (code) => {
    if (code === 0) {
      snappRecords.gridData = snappRecords.products;
    } else {
      snappRecords.gridData = snappRecords.products.filter(x => x.menuCategory.categoryCode === code);
    }
    setSnappRecords({ ...snappRecords });
  }

  const [statusModel, setStatusModel] = useState({
    id: 0,
    active: false,
    disable: false,
    disableUntil: '',
    vendorCode: '',
    snappToken: ''
  });

  const [statusModalModel, setStatusModalModel] = useState({
    show: false
  });

  const mapStatusModel = (data) => {
    statusModel.id = data.id;
    statusModel.active = data.active;
    statusModel.disable = data.disable;
    statusModel.disableUntil = methods.toPersianDate(data.disableUntil, 'jYYYY/jMM/jDD');
    statusModel.vendorCode = snappSecurity.vendorCode;
    statusModel.snappToken = snappSecurity.snappToken;
    setStatusModel({ ...statusModel });
  }

  const resetStatusForm = () => {
    statusModel.id = 0;
    statusModel.active = true;
    statusModel.disable = false;
    statusModel.disableUntil = '';
    setStatusModel({ ...statusModel });
  }

  const openItemStatus = (item) => {
    mapStatusModel(item);
    console.log(statusModel);
    statusModalModel.show = true;
    setStatusModalModel({ ...statusModalModel });
  }

  const setSnappMenuStatus = async () => {
    setLoading(true);
    let resp = await apiMethod.changeMenuStatusSnapp(statusModel);
    if (methods.showApiErrors(resp))
      getGridData();
    statusModalModel.show = false;
    setStatusModalModel({ statusModalModel });
    resetStatusForm();
    setLoading(false);
  }


  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div>
              <Link to={`/sale/${branchId}/snappManager/SnappMenuGroups/${unitId}`} className='d-none d-lg-block text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/snappManager/SnappMenuGroups/${unitId}`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                محصولات دسته‌بندی/ {pageTitle}
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p> محصولات دسته‌بندی/ {pageTitle}</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={gridFilter.title}
                        onChange={(e) => { setGridFilter({ ...gridFilter, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>ایجاد محصول</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">ID</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">دسته</th>
                      <th scope="col vertical-center">شماره ترتیب</th>
                      <th scope="col vertical-center">قیمت</th>
                      <th scope="col vertical-center">هزینه ظرف</th>
                      <th scope="col vertical-center">درصد مالیات</th>
                      <th scope="col vertical-center">وضعیت</th>
                      <th scope="col vertical-center">تاپینگ ها</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row">{((gridFilter.part - 1) * gridFilter.size) + index + 1}</td>
                        <td>{item.id}</td>
                        <td>{item.title}</td>
                        <td>{item.categoryTitle}</td>
                        <td>{item.position}</td>
                        <td>{methods.addNumSeperator(item.price)}</td>
                        <td>{methods.addNumSeperator(item.containerPrice)}</td>
                        <td>{item.vat}</td>
                        <td>
                          <button onClick={() => {
                            openItemStatus(item);
                          }} type='button' className={item.active && !item.disable ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm'}>
                            {item.active ? 'فعال' : 'غیرفعال'} - {item.disable ? 'ناموجود' : 'موجود'}
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              navigate(`/sale/${branchId}/snappManager/${unitId}/${categoryId}/SnappMenuToppings/${item.id}`);
                            }}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            تاپینگ ها
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => getItemInfo(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَSanpToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {gridFilter.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const Modal = () => {
  const updateAllSchedules = (startTime, endTime) => {
    const updatedSchedules = schedules.map(schedule => ({
      ...schedule,
      start: startTime,
      stop: endTime
    }));
    setSchedules(updatedSchedules);
  };

  return (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="modal-dialog modal-lg" role="document" >
        <div className="modal-content px-3">
          <div className="modal-header">
            <h5 className="modal-title">ایجاد / ویرایش منوی اسنپ</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            >
            </button>
          </div>
          <div className="modal-body">
            {showMenuSearch && (
              <>
                <div className='col-md-6'>
                  <label htmlFor="funit" className="form-label">جستجو در منوهای‌دسته</label>
                  <div className="hstack">
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={saleMenuFilter.title}
                      onChange={(e) => { setSaleMenuFilter({ ...saleMenuFilter, title: e.target.value, part: 1 }) }}
                    />
                    <button type='button' className='btn btn-purple me-1'
                      onClick={searchSaleMenuItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button type='button' className='btn btn-outline-info'
                      onClick={clearSaleMenuSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className='border rounded mt-4'>
                  <p className='bg-light rounded-top p-3'>انتخاب منوهای دسته</p>
                  <div className='table-responsive saletable m-3'>
                    <table className="table table-striped table-md align-middle" >
                      <thead className=''>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center">دسته بندی</th>
                          <th scope="col vertical-center" width="50px">عملیات</th>
                        </tr>
                      </thead>
                      <tbody className=''>
                        {saleMenus.filter(x => !x.isExist).map((item, index) => (
                          <tr key={item.id}>
                            <th scope="row">{((saleMenuFilter.part - 1) * saleMenuFilter.size) + index + 1}</th>
                            <td>{item.title}</td>
                            <td>{item.categoryTitle}</td>
                            <td>
                              <button type="button" className="btn btn-sm btn-purple"
                                onClick={() => setMenu(item)}
                              >
                                افزودن
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {saleMenuFilter.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { SaleMenuMovePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {SaleMenuMakePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { SaleMenuMovePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </div>
                </div>
              </>
            )}
            {!showMenuSearch && (
              <>
                <div className='mb-4'>
                  <Link
                    onClick={switchToAllCategoriesView}
                    className='link back-link'
                  >
                    <span><img src={back} className="" alt="return" /></span>
                    بازگشت
                  </Link>
                </div>
                <div className='row mb-3'>
                  <div className='col-6'>
                    <button onClick={() => { getSnappData() }} className='btn btn-outline-purple'>انتخاب محصول موجود در اسنپ</button>
                  </div>
                  <div className='col-4'>
                  </div>
                </div>
                {snappRecords.visibility && (
                  <>
                    <div className='snapp-records mb-4'>
                      <div className='row mb-3'>
                        <div className='col-4'>
                          <select onChange={(e) => { filterSnappData(e.target.value) }} className='form-select ch-bt'>
                            <option value={0}>انتخاب دسته</option>
                            {snappRecords.categories.map((item, index) => (
                              <option key={index} value={item.categoryCode}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='table-responsive'>
                        <table className='table table-bordered'>
                          <thead>
                            <tr>
                              <th>عنوان</th>
                              <th>کد</th>
                              <th>شناسه</th>
                              <th>قیمت</th>
                              <th>توضیحات</th>
                              <th>وضعیت</th>
                              <th width="130px">انتخاب</th>
                            </tr>
                          </thead>
                          <tbody>
                            {snappRecords.gridData.map((item, index) => (
                              <tr key={index}>
                                <td>{item.title}</td>
                                <td>{item.productCode}</td>
                                <td>{item.productId}</td>
                                <td>{methods.addNumSeperator(item.price)}</td>
                                <td>{item.description}</td>
                                <td>
                                  <p>{item.isActive && <span className='text-success'>فعال</span>}{!item.isActive && <span className='text-danger'>غیرفعال</span>}</p>
                                  <p>
                                    {!item.disabled && <span className='text-success'>موجود</span>}
                                    {item.disabled && <><span className='text-danger'>ناموجود تا تاریخ: {methods.toPersianDate(item.disabledUntil, 'jYYYY/jMM/jDD')}</span></>}
                                  </p>
                                </td>
                                <td>
                                  <div className='text-center'>
                                    <button onClick={() => { setFromSnapp(item) }} className='btn btn-purple btn-sm'>انتخاب دسته</button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}

                {selectedSnappItem != null &&
                  <div className='table-responsive'>
                    <table className='table table-bordered'>
                      <tbody>
                        <tr>
                          <td colSpan={4} className='text-center bg-light'><b>آیتم انتخابی اسنپ</b></td>
                        </tr>
                        <tr>
                          <td>عنوان</td>
                          <td>کد</td>
                          <td>شناسه</td>
                          <td>قیمت</td>
                        </tr>
                        <tr>
                          <td>{selectedSnappItem.title}</td>
                          <td>{selectedSnappItem.productCode}</td>
                          <td>{selectedSnappItem.productId}</td>
                          <td>{methods.addNumSeperator(selectedSnappItem.price)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }

                <form className="row g-3" autoComplete="off">
                  <div className="col-md-6">
                    <label htmlFor="title" className="form-label required-label">عنوان</label>
                    <input type="text" className="form-control" id="title" name="title"
                      value={formModel.title}
                      onChange={(e) => {
                        formModel.title = e.target.value;
                        setFormModel({ ...formModel });
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="ddlMenu" className="form-label required-label">منوی متصل</label>
                    <select
                      id="ddlMenu"
                      className="form-select"
                      aria-label="menu"
                      value={formModel.saleMenuId}
                      onChange={(e) => {
                        changeMenuItem(e.target.value);
                      }}
                    >
                      {ddlMenus.map((item, index) => (
                        <option value={item.id} key={index}>{item.title}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="position" className="form-label required-label">ترتیب نمایش</label>
                    <input type="text" className="form-control" id="position"
                      value={formModel.position}
                      onChange={(e) => {
                        const position = parseInt(e.target.value);
                        setFormModel({ ...formModel, position: isNaN(position) ? '' : position });
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="price" className="form-label required-label">قیمت</label>
                    <input type="text" className="form-control" id="price"
                      value={methods.addNumSeperator(formModel.price)}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const price = parseInt(inputValue.replace(/,/g, ''));
                        setFormModel({ ...formModel, price: isNaN(price) ? '' : price });
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="containerPrice" className="form-label required-label">هزینه ظرف </label>
                    <input type="text" className="form-control" id="containerPrice"
                      value={methods.addNumSeperator(formModel.containerPrice)}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const containerPrice = parseInt(inputValue.replace(/,/g, ''));
                        setFormModel({ ...formModel, containerPrice: isNaN(containerPrice) ? '' : containerPrice });
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vat" className="form-label required-label">درصد مالیات </label>
                    <input type="text" className="form-control" id="vat"
                      value={formModel.vat}
                      onChange={(e) => {
                        const vat = parseInt(e.target.value);
                        setFormModel({ ...formModel, vat: isNaN(vat) ? '' : vat });
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="startTime" className="form-label required-label">ساعت شروع</label>
                    <input
                      id="startTime"
                      value={formModel.startTime}
                      onChange={(e) => {
                        const newStartTime = e.target.value;
                        formModel.startTime = newStartTime;
                        setFormModel({...formModel});
                        updateAllSchedules(newStartTime, formModel.endTime);
                      }}
                      type="time" 
                      className="form-control"
                      dir="ltr"
                    />
                    
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="endTime" className="form-label required-label">ساعت پایان</label>
                    <input
                      id="endTime"
                      value={formModel.endTime}
                      onChange={(e) => {
                        const newEndTime = e.target.value;
                        formModel.endTime = newEndTime;
                        setFormModel({...formModel});
                        updateAllSchedules(formModel.startTime, newEndTime);
                      }}
                      type="time" 
                      className="form-control"
                      dir="ltr"
                    />
                  </div>
                  
                  <div>
                    <p>زمانبندی نمایش در اسنپ</p>
                    <div className="mb-3">
                      {schedules.map((item, index) => (
                        <div className="row" key={index}>
                          <div className="col-sm-3">
                            <label className="form-label">{item.dayTitle}</label>
                          </div>
                          <div className="col-sm-3">
                            <label className="form-label">ساعت شروع</label>
                            <input 
                              value={item.start}
                              onChange={(e) => {
                                item.start = e.target.value;
                                setSchedules([...schedules]);
                              }}
                              type="time" 
                              className="form-control" 
                            />
                          </div>
                          <div className="col-sm-3">
                            <label className="form-label">ساعت پایان</label>
                            <input 
                              value={item.stop}
                              onChange={(e) => {
                                item.stop = e.target.value;
                                setSchedules([...schedules]);
                              }}
                              type="time" 
                              className="form-control" 
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="description" className="form-label required-label">توضیحات</label>
                    <textarea type="text" className="form-control" id="description" name="description"
                      value={formModel.description}
                      onChange={(e) => {
                        formModel.description = e.target.value;
                        setFormModel({ ...formModel })
                      }}
                    />
                  </div>
                </form>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn custome-btn btn-link-purple "
              onClick={closeModal}
            >
              انصراف
            </button>
            <button type="button"
              onClick={() => { createItem() }}
              className="btn custome-btn btn-purple w-25 ">ذخیره</button>
          </div>
        </div >
      </div >
    </div >
  )
};

  const statusModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: statusModalModel.show ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">وضعیت منو</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  statusModalModel.show = false;
                  setStatusModalModel({ ...statusModalModel });
                }}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className='row'>
                <div className='col-md-12'>
                  <div class="form-check mb-3">
                    <input checked={statusModel.active} onChange={(e) => {
                      statusModel.active = e.target.checked;
                      setStatusModel({ ...statusModel });
                    }} class="form-check-input" type="checkbox" value="" id="chbactive" />
                    <label class="form-check-label" for="chbactive">
                      فعال بودن نمایش
                    </label>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div class="form-check mb-3">
                    <input checked={statusModel.disable} onChange={(e) => {
                      statusModel.disable = e.target.checked;
                      setStatusModel({ ...statusModel });
                    }} class="form-check-input" type="checkbox" value="" id="chbdisable" />
                    <label class="form-check-label" for="chbdisable">
                      ناموجود است
                    </label>
                  </div>
                </div>
                {statusModel.disable &&
                  <>
                    <div className='col-md-6'>
                      <div className='form-group mb-2'>
                        <label htmlFor="disabledate" className="form-label">ناموجود تا تاریخ</label>
                        <DatePicker
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-center"
                          format="YYYY/MM/DD"
                          value={statusModel.disableUntil}
                          onChange={(value) => {
                            if (value)
                              statusModel.disableUntil = value.format('YYYY/MM/DD');
                            else
                              statusModel.disableUntil = "";
                            setStatusModel({ ...statusModel });
                          }}
                          inputClass="form-control"
                          inputId="disabledate"
                          containerStyle={{
                            width: "100%"
                          }}
                        />
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={() => {
                  statusModalModel.show = false;
                  setStatusModalModel({ ...statusModalModel });
                  resetStatusForm();
                }}
              >
                انصراف
              </button>
              <button type="button"
                onClick={() => { setSnappMenuStatus() }}
                className="btn custome-btn btn-purple w-25 ">ذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showModal && Modal()}
      {showDeleteModal &&
        <DeleteModalSnapp
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'دسته‌بندی'}
        />
      }
      {statusModalModel.show && statusModal()}
    </>
  );
}

export default SnappMenus;